import { createFileRoute } from "@tanstack/react-router";
import { Quotas } from "../../../features/settings/quotas";

export const Route = createFileRoute("/_authed/$org/settings/quotas")({ component: QuotasPage });

function QuotasPage() {
  return <Quotas org={Route.useParams().org} />;
}
